import React, { useEffect, useState } from "react";
import queryString, { parse } from 'query-string';
import history from "../../history";
import sorumluSecimListesi from "../../services/sorumluSecimListesi";
import sorumluGuncelle from "../../services/sorumluGuncelle";
import { Card, Row, Col, message, Spin, Form, Input, Select, Button, Tooltip as TooltipAnd } from 'antd';
import * as util from "../Helpers/Util";
import * as validation from "../BForm/validation";
const { Option } = Select;
const parsed = queryString.parse(history.location.search);
const formItemStyle = {
    marginLeft: 10
}
const formLayout = {
    labelCol: {
        span: 4
    },
    wrapperCol: {
        span: 8
    }
}
const SorumluSecimForm = () => {

    const [spining, setSpining] = useState(true);
    const [form] = Form.useForm();
    const [raportorList, setRaportorList] = useState([]);

    const { getFieldDecorator, getFieldValue } = form;

    const loadForm = async () => {
        setSpining(true);
        await sorumluSecimListesi(parsed.basvuruId).then(resp => {
            if (resp.data.success) {
                setRaportorList(resp.data.result);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message));
        });
        setSpining(false);
    }
    useEffect(() => {
        loadForm();
    }, []);


    const onFinish = async(values) => {
        setSpining(true);

        let sorumluGuncelleRequest = {
            BasvuruId : parseInt(parsed.basvuruId),
            SorumluDetails : []
        };

        await Object.keys(values).forEach(function (key) {
            if (!util.isNullOrEmptyOrUndefined(values[key])) {                
                sorumluGuncelleRequest.SorumluDetails.push({
                    SorumluKullaniciId : values[key],
                    SorumluColumnName : key
                });
            }
        });

        if(sorumluGuncelleRequest.SorumluDetails.length > 0){

            await sorumluGuncelle(sorumluGuncelleRequest).then(resp => {
                if(!resp.data.success){
                    util.errorMessage(resp.data.message);
                }else{
                    util.successMessage(resp.data.message);
                    window.parent.location.reload();
                }
            })
            setSpining(false);
        }else{
            util.errorMessage("Sorumlular değişmediği veya başvuru güncellenmeye uygun durumda olmadığı için sorumlu güncelleme yapılamamıştır.");
            setSpining(false);
        }            
    }


    return (
        <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
            <Card bodyStyle={{ padding: "10", fontWeight: "bold" }}>
                Sorumlu Güncelle
            </Card>
            <Form key={"sorumluForm"} form={form}  {...formLayout} onFinish={onFinish}>
                {raportorList.map(key => (
                    <Form.Item key={key.kolonAdi} label={key.editorAdi} name={key.kolonAdi} style={formItemStyle} labelAlign="left">
                        <Select
                            showSearch
                            allowClear
                            defaultValue=
                            {key.sorumluKullaniciId != null ? key.sorumluKullaniciId : []}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            disabled={key.isReadonly}>
                            {key.kullaniciList && key.kullaniciList.map(bt => <Option key={key.kullaniciKodu} value={bt.kullaniciKodu}>{bt.adSoyad}</Option>)}
                        </Select>
                    </Form.Item>
                ))}
                <Row>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
}

export default SorumluSecimForm;